import "../../../../assets/presentation/components/controls/text-input/text-input-container-D0zJXvm0.css";
/* empty css                     */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-container.tsx
var TextInputContainer = ({ children, className, testId, onClick }) => {
	return /* @__PURE__ */ jsx("div", {
		className: classNames("text-input-container", className),
		"data-testid": testId,
		onClick,
		children
	});
};
//#endregion
export { TextInputContainer };

//# sourceMappingURL=text-input-container2.js.map